interface Props {
  size?: number;
  color?: string;
}

const MoreIcon = (props: Props) => {
  const { color, size = 15 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={color || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 8C3.75 9.03553 2.91053 9.875 1.875 9.875C0.839467 9.875 0 9.03553 0 8C0 6.96447 0.839467 6.125 1.875 6.125C2.91053 6.125 3.75 6.96447 3.75 8Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M9.375 8C9.375 9.03553 8.53553 9.875 7.5 9.875C6.46447 9.875 5.625 9.03553 5.625 8C5.625 6.96447 6.46447 6.125 7.5 6.125C8.53553 6.125 9.375 6.96447 9.375 8Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M13.125 9.875C14.1606 9.875 15 9.03553 15 8C15 6.96447 14.1606 6.125 13.125 6.125C12.0894 6.125 11.25 6.96447 11.25 8C11.25 9.03553 12.0894 9.875 13.125 9.875Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default MoreIcon;
